var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { width: _vm.dialogWidth },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.save.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        {
          staticClass: "resizable-card",
          class: { "no-select": _vm.resizing },
          style: { height: _vm.dialogHeight + "px" },
        },
        [
          _c("v-card-title", [
            _c("span", { staticClass: "headline" }, [_vm._v("Level Config")]),
          ]),
          _c(
            "v-card-text",
            { staticClass: "resizable-card__body" },
            [
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4", md: "4" } },
                    [
                      _c("v-text-field", {
                        directives: [
                          { name: "ascii-only", rawName: "v-ascii-only" },
                        ],
                        attrs: { label: "Key" },
                        model: {
                          value: _vm.model.key,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.model,
                              "key",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "model.key",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "2", md: "2" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Stage", "hide-details": "" },
                        model: {
                          value: _vm.model.stage,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "stage", _vm._n($$v))
                          },
                          expression: "model.stage",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "2", md: "2" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Price", "hide-details": "" },
                        model: {
                          value: _vm.model.price,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "price", _vm._n($$v))
                          },
                          expression: "model.price",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "2", md: "2" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Win Percent", "hide-details": "" },
                        model: {
                          value: _vm.model.winPercent,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "winPercent", _vm._n($$v))
                          },
                          expression: "model.winPercent",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "pt-6", attrs: { dense: "" } },
                [
                  _c(
                    "v-expansion-panels",
                    [
                      _c("r-treasure-piece-config-panel", {
                        attrs: {
                          items: _vm.model.pieces,
                          title: "Piece Config",
                        },
                        on: {
                          "update:items": function ($event) {
                            return _vm.$set(_vm.model, "pieces", $event)
                          },
                        },
                      }),
                      _c("r-reward-panel", {
                        attrs: {
                          model: _vm.model.winReward,
                          title: "Win Reward",
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "winReward", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "resizable-card__actions" },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.save },
                },
                [_vm._v(" Save ")]
              ),
            ],
            1
          ),
          _c("div", {
            staticClass: "resize-handle",
            on: { mousedown: _vm.startResize },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }